export const STYLE_DESKTOP_LIST_ITEM = {
  px: 2,
  border: "1px solid hsl(from var(--colorBorder) h s 88%)",
  borderRadius: "4px",
  marginTop: "8px",
  marginBottom: "8px",
  "&:hover": {
    border: "1px solid hsl(from var(--colorBorder) h s 60%)",
  },
};

export const STYLE_MOBILE_LIST_ITEM = {
  px: 2,
  border: "1px solid hsl(from var(--colorBorder) h s 88%)",
  borderRadius: "4px",
  marginTop: "4px",
  marginBottom: "4px",
  "&:hover": {
    border: "1px solid hsl(from var(--colorBorder) h s 60%)",
  },
};

export const STYLE_CARD_HOVER = {
  "&:hover": { border: "1px solid hsl(from var(--colorBorder) h s 60%)" },
};

export const STYLE_CARD_LINK_HOVER = {
  "&:hover": { transform: "scale(1.05)", backgroundColor: "transparent" },
};

export const STYLE_LEARNING_ACTIVITY_CARD_LINK = {
  display: "flex",
  alignItems: "center",
  lineHeight: "42px",
  color: "var(--colorTextPrimary)",
};

export const STYLE_LIST_ITEM_DESCRIPTION = {
  maxWidth: {
    xs: "100vw",
    sm: "100vw",
    md: "60vw",
  },
};
